import {
    Avatar,
    Button,
    Col,
    Divider,
    Image,
    Input,
    List,
    Row,
    Upload,
    message as AntMessage,
} from "antd";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { PaperClipOutlined } from "@ant-design/icons";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import { socket } from "../../Utils/Socket";
import { API_URL, apiCall } from "../../API/RestApi";

const { TextArea } = Input;

function CustomerChat() {
    // 🔐 Token test user
    const token =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNjIzOSJ9LCJpYXQiOjE3NTk5ODU3NDR9.r2q1egnTEVi3HY5-aGx7x3nq2XiyBOfZY3vXVwBAUlc";

    const decoded = jwtDecode(token);
    const userId = decoded.user.id;

    const [chat, setChat] = useState(null);
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);

    const titlePage = "Customer Live Chat";

    // ✅ Ambil chat user aktif
    const fetchChat = async () => {
        try {
            setLoading(true);
            const res = await apiCall({
                method: "GET",
                url: `${API_URL}/v2/chat/user`,
                    data: {
                        headers: { Authorization: `Bearer ${token}` },
                    },
            });

            console.log("📦 Chat list:", res);

            if (res.status === 'success' && res.data.length > 0) {
                const active = res.data[0];
                setChat(active);
                joinRoom(active.ChatId);
                fetchMessages(active.ChatId);
            } else {
                // Jika user belum punya chat, buat baru
                const createRes = await apiCall({
                    method: "POST",
                    url: `${API_URL}/v2/chat/user`,
                    data: {
                        headers: { Authorization: `Bearer ${token}` },
                    },
                });
                if (createRes.status === "success") {
                    setChat(createRes.data);
                    joinRoom(createRes.data.ChatId);
                }
            }
        } catch (err) {
            console.error("Error fetching chat:", err);
        } finally {
            setLoading(false);
        }
    };

    // ✅ Ambil semua pesan chat user
    const fetchMessages = async (chatId) => {
        try {
            const res = await apiCall({
                method: "GET",
                url: `${API_URL}/v2/chat/user/${chatId}`,
                data: {
                    headers: { Authorization: `Bearer ${token}` },
                },
            });

            console.log("📜 Messages:", res);

            if (res.status === "success" && res.data.length > 0) {
                setMessages(res.data.reverse());
            } else {
                setMessages([]);
            }
        } catch (err) {
            console.error("Error fetching chat detail:", err);
        }
    };

    // ✅ Join ke room socket.io
    const joinRoom = (chatId) => {
        if (socket && chatId) {
            socket.emit("joinRoom", `chat_${chatId}`);
            console.log("🟢 Joined chat room:", `chat_${chatId}`);
        }
    };

    // ✅ Kirim pesan (via API + socket realtime)
    const sendMessage = async (fileEvent = null) => {
        if (!chat) {
            AntMessage.warning("Tidak ada chat aktif. Buat chat dulu.");
            return;
        }

        const msg = text || (fileEvent ? fileEvent.file.name : "");
        if (!msg.trim()) return;

        try {
            setLoading(true);

            // 🔥 Kirim ke API (simpan ke DB)
            const res = await apiCall({
                method: "POST",
                url: `${API_URL}/v2/chat/user/message`,
                data: {
                    data: {
                        ChatId: chat.ChatId,
                        Message: msg,
                    },
                    headers: { Authorization: `Bearer ${token}` },
                },
            });

            if (res.status === 'success') {
                const messageData = res.data.data;

                // 🔥 Broadcast realtime ke room
                socket.emit("sendMessage", {
                    ChatId: chat.ChatId,
                    UserId: userId,
                    Message: msg,
                    Type: "text",
                    Url: null,
                });

                // 🔄 Tambahkan ke tampilan sementara
                setMessages((prev) => [...prev, messageData]);
                setText("");
            }
        } catch (err) {
            console.error("Error sending message:", err);
            AntMessage.error("Gagal mengirim pesan.");
        } finally {
            setLoading(false);
        }
    };

    // ✅ Load chat saat pertama kali buka
    useEffect(() => {
        fetchChat();
    }, []);

    // ✅ Dengar event pesan baru dari socket
    useEffect(() => {
        socket.on("newMessage", (newMsg) => {
            console.log("📩 Received new message:", newMsg);
            if (chat && newMsg.ChatId === chat.ChatId) {
                setMessages((prev) => [...prev, newMsg]);
            }
        });

        return () => socket.off("newMessage");
    }, [chat]);

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            <h3>{titlePage}</h3>

            <Row>
                <Col span={24}>
                    {chat ? (
                        <>
                            {/* 💬 LIST PESAN */}
                            <div
                                style={{
                                    overflow: "auto",
                                    background: "#f7f7f7",
                                    padding: 16,
                                    height: 480,
                                    borderRadius: 8,
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                }}
                            >
<List
  dataSource={messages || []}
  rowKey={(item) => item?.ChatDetailId || Math.random()} // ✅ pastikan key selalu ada
  renderItem={(item) => {
    if (!item) return null; // ✅ hindari item undefined
    return (
      <div
        key={item.ChatDetailId || Math.random()}
        style={{
          display: "flex",
          flexDirection:
            item.UserId === userId ? "row-reverse" : "row",
          marginBottom: 10,
        }}
      >
        <div
          style={{
            backgroundColor:
              item.UserId === userId ? "#0088ff" : "#f6f6ff",
            color: item.UserId === userId ? "white" : "black",
            padding: 10,
            borderRadius: 10,
            maxWidth: "70%",
            wordBreak: "break-word",
          }}
        >
          {item.Type === "file" && item.Url ? (
            <Image
              src={item.Url}
              width={120}
              height={120}
              style={{ borderRadius: 8 }}
            />
          ) : (
            item.Message || "(Pesan kosong)"
          )}
          <div
            style={{
              fontSize: 10,
              color: item.UserId === userId ? "#ddd" : "#999",
              marginTop: 4,
              textAlign:
                item.UserId === userId ? "right" : "left",
            }}
          >
            {item.CreatedAt
              ? moment(item.CreatedAt).format("D MMM YYYY, HH:mm:ss")
              : "-"}
          </div>
        </div>
      </div>
    );
  }}
/>

                            </div>

                            {/* 📝 INPUT PESAN */}
                            <Row style={{ marginTop: 10 }}>
                                <Col span={2}>
                                    <Upload
                                        showUploadList={false}
                                        customRequest={(op) => sendMessage(op)}
                                    >
                                        <Button type="primary" icon={<PaperClipOutlined />} />
                                    </Upload>
                                </Col>
                                <Col span={18}>
                                    <TextArea
                                        rows={1}
                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                        placeholder="Ketik pesan..."
                                        onPressEnter={() => sendMessage()}
                                    />
                                </Col>
                                <Col span={4} style={{ textAlign: "right" }}>
                                    <Button
                                        type="primary"
                                        onClick={() => sendMessage()}
                                        style={{ marginLeft: 8 }}
                                        loading={loading}
                                    >
                                        Kirim
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <div style={{ textAlign: "center", marginTop: 80 }}>
                            <Image
                                preview={false}
                                src="https://cdn-icons-png.flaticon.com/512/2972/2972159.png"
                                width={100}
                                height={100}
                            />
                            <h4>Halo 👋</h4>
                            <p>
                                Belum ada chat aktif. Klik tombol di bawah untuk memulai
                                percakapan.
                            </p>
                            <Button type="primary" onClick={fetchChat} loading={loading}>
                                Mulai Chat
                            </Button>
                        </div>
                    )}
                </Col>
            </Row>
        </>
    );
}

export default CustomerChat;
